
<div class="user-menu">
  <div class="user-menu-list">
    <!-- Not connected -->
    @if (!user) {
      <div class="user-menu-list-item"
        [routerLink]="['/login']"
      >
        <i class="fa fa-sign-in"></i>
        <p><b>{{'marketplace.header.user-menu.login'|transloco}}</b></p>
      </div>
      <div class="user-menu-list-item"
           [routerLink]="['/register']"
      >
        <i class="fa fa-user-plus"></i>
        <p>{{'marketplace.header.user-menu.register'|transloco}}</p>
      </div>

      <hr/>

      <div class="join-photographer"
           [routerLink]="['/manage']"
      >
        <div class="join-photographer__content">
          <h3>{{'marketplace.header.user-menu.join-photographer.title'|transloco}}</h3>
          <p>{{'marketplace.header.user-menu.join-photographer.content'|transloco}}</p>
        </div>
        <img src="assets/images/icon-512.png" alt="ShutterFlow">
      </div>
    }

    <!-- Connected -->
    @if (user) {
      @if (isAdmin()) {
        <div class="user-menu-list-item"
          [routerLink]="['/admin']"
          >
          <i class="fa fa-user-shield"></i>
          <p>{{'marketplace.header.user-menu.admin'|transloco}}</p>
        </div>
      }
      @if (isPhotographer()) {
        <div class="user-menu-list-item"
          [routerLink]="['/manage']"
          >
          <i class="fa fa-user"></i>
          <p>{{'marketplace.header.user-menu.manage'|transloco}}</p>
        </div>
      }
      @if (isCustomer()) {
        <div class="user-menu-list-item"
          [routerLink]="['/my-account']"
          >
          <i class="fa fa-user"></i>
          <p>{{'marketplace.header.user-menu.my-orders'|transloco}}</p>
        </div>
        <div class="user-menu-list-item"
          [routerLink]="['/my-discounts']"
          >
          <i class="fa-solid fa-gift"></i>
          <p>{{'marketplace.header.user-menu.my-discounts'|transloco}}</p>
        </div>
      }

      <hr/>
      @if (isCustomer()) {
        <a class="user-menu-list-item"
          [href]="getCguClientHref()"
          target="_blank"
          rel="noopener noreferrer"
          >
          <i class="fa-solid fa-arrow-up-right-from-square"></i>
          <p>{{ 'sidebar.cgu'|transloco }}</p>
        </a>
      }
      <a class="user-menu-list-item"
        [href]="getPrivacyPolicyHref()"
        target="_blank"
        rel="noopener noreferrer"
        >
        <i class="fa-solid fa-arrow-up-right-from-square"></i>
        <p>{{ 'sidebar.privacy-policy'|transloco }}</p>
      </a>
      <a class="user-menu-list-item"
        [href]="getLegalNoticeHref()"
        target="_blank"
        rel="noopener noreferrer"
        >
        <i class="fa-solid fa-arrow-up-right-from-square"></i>
        <p>{{ 'sidebar.legal-notice'|transloco }}</p>
      </a>
      <hr/>
      <div class="user-menu-list-item"
        (click)="logout()"
        >
        <i class="fa fa-sign-out"></i>
        <p>{{'marketplace.header.user-menu.logout'|transloco}}</p>
      </div>
    }

  </div>
</div>
